import { createSlice } from '@reduxjs/toolkit';

import eventBus from '@utils/eventBus';
import { EventType } from '@utils/eventBus/eventTypes';

import { handleAdminCreateIngredient, handleGetAdminIngredientsSearch } from './actions';
import { IAdminIngredientsSearchState } from './slice.interface';

const initialState: IAdminIngredientsSearchState = {
  data: null,
  isLoading: false,
  addIngredientModalOpen: false,
  isCreateIngredientPending: false,
  searchStringForAddIngredientModal: '',
};

export const ingredientsSearchSlice = createSlice({
  name: 'admin-ingredients-search',
  initialState,
  reducers: {
    removeAdminIngredientsSearch: state => {
      state.data = null;
      state.isLoading = false;
    },
    openAddIngredientModal: state => {
      state.addIngredientModalOpen = true;
    },
    closeAddIngredientModal: state => {
      state.addIngredientModalOpen = false;
      state.searchStringForAddIngredientModal = '';
    },
    setSearchStringForAddIngredientModal: (
      state: IAdminIngredientsSearchState,
      action: { payload: string },
    ) => {
      state.searchStringForAddIngredientModal = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetAdminIngredientsSearch.pending, (state: IAdminIngredientsSearchState) => {
        state.isLoading = true;
      })
      .addCase(handleAdminCreateIngredient.pending, (state: IAdminIngredientsSearchState) => {
        state.isCreateIngredientPending = true;
      })
      .addCase(handleAdminCreateIngredient.rejected, (state: IAdminIngredientsSearchState) => {
        state.isCreateIngredientPending = false;
      })
      .addCase(
        handleAdminCreateIngredient.fulfilled,
        (state: IAdminIngredientsSearchState, action) => {
          state.isCreateIngredientPending = false;
          const payload =
            action?.payload?.data && typeof action.payload.data === 'object'
              ? action.payload.data
              : {};
          eventBus.emit(EventType.ADMIN_CREATE_NEW_INGREDIENT_SUCCESS, payload);
        },
      )
      .addCase(
        handleGetAdminIngredientsSearch.fulfilled,
        (state: IAdminIngredientsSearchState, action) => {
          const { page, pageCount } = action.payload.data.pagination;

          if (pageCount === 1 || page === 1) {
            state.data = action.payload.data;
          } else {
            state.data = {
              ...action.payload.data,
              tableData: [...(state.data?.tableData ?? []), ...action.payload.data.tableData],
            };
          }

          state.isLoading = false;
        },
      );
  },
});

export const {
  removeAdminIngredientsSearch,
  openAddIngredientModal,
  closeAddIngredientModal,
  setSearchStringForAddIngredientModal,
} = ingredientsSearchSlice.actions;

export default ingredientsSearchSlice.reducer;
